/*
  more-list.js — 一覧の「＋ さらにN件（残りM件）」／「閉じる」（2026-09-24）
  レビュー（review-app の product-reviews.js initList）と同じ操作感を、テーマ側の一覧で共通化したもの。
  使う側: sections/metaobject-news.liquid / sections/metaobject-media.liquid（snippets/more-list-button.liquid）

  - 全件はサーバー側で HTML に書き出してある。ここでは表示を絞るだけ（JS 無効・JS を実行しないクローラーでは全件が見える）
  - data-more-root … data-more-initial（最初に見せる件数）・data-more-step（＋1回で増やす件数）
  - data-more-list の直下の <li> が対象
  - URL の #id が隠れている項目を指していたら、そこまで開いてスクロールする（構造化データ・AI回答からのリンク用）
*/
(function () {
  if (window.__tsMoreList) return;
  window.__tsMoreList = true;

  function init(root) {
    if (root.__moreReady) return;
    root.__moreReady = true;
    var list = root.querySelector('[data-more-list]');
    if (!list) return;
    var initial = parseInt(root.getAttribute('data-more-initial'), 10);
    var step = parseInt(root.getAttribute('data-more-step'), 10) || 3;
    if (isNaN(initial) || initial < 0) initial = 4;
    var wrap = root.querySelector('[data-more-wrap]');
    var btn = root.querySelector('[data-more-btn]');
    var text = root.querySelector('[data-more-text]');
    var closeBtn = root.querySelector('[data-more-close]');
    var limit = initial;

    function items() {
      var out = [];
      for (var i = 0; i < list.children.length; i++) {
        if (list.children[i].tagName === 'LI') out.push(list.children[i]);
      }
      return out;
    }
    function apply() {
      var its = items();
      if (limit > its.length) limit = its.length;
      for (var i = 0; i < its.length; i++) its[i].hidden = i >= limit;
      var rest = its.length - limit;
      if (wrap) wrap.hidden = rest <= 0;
      if (btn) btn.setAttribute('aria-expanded', rest <= 0 ? 'true' : 'false');
      if (text && rest > 0) {
        var next = rest < step ? rest : step;
        text.textContent = 'さらに' + next + '件（残り' + rest + '件）';
      }
      if (closeBtn) closeBtn.hidden = limit <= initial;
    }
    function revealHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var target = document.getElementById(id);
      if (!target || !list.contains(target)) return;
      var its = items();
      for (var i = 0; i < its.length; i++) {
        if (its[i] === target || its[i].contains(target)) {
          if (i >= limit) { limit = i + 1; apply(); }
          target.scrollIntoView({ block: 'start' });
          return;
        }
      }
    }

    if (btn) btn.addEventListener('click', function () { limit += step; apply(); });
    if (closeBtn) closeBtn.addEventListener('click', function () {
      limit = initial;
      apply();
      (root.querySelector('h1, h2, h3') || root).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    window.addEventListener('hashchange', revealHash);
    apply();
    revealHash();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-more-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
